"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFrameProductSearchModel = instanceOfFrameProductSearchModel;
exports.FrameProductSearchModelFromJSON = FrameProductSearchModelFromJSON;
exports.FrameProductSearchModelFromJSONTyped = FrameProductSearchModelFromJSONTyped;
exports.FrameProductSearchModelToJSON = FrameProductSearchModelToJSON;
exports.FrameProductSearchModelToJSONTyped = FrameProductSearchModelToJSONTyped;
/**
 * Check if a given object implements the FrameProductSearchModel interface.
 */
function instanceOfFrameProductSearchModel(value) {
    return true;
}
function FrameProductSearchModelFromJSON(json) {
    return FrameProductSearchModelFromJSONTyped(json, false);
}
function FrameProductSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'frameNo': json['frameNo'] == null ? undefined : json['frameNo'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}
function FrameProductSearchModelToJSON(json) {
    return FrameProductSearchModelToJSONTyped(json, false);
}
function FrameProductSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'frameNo': value['frameNo'],
        'status': value['status'],
    };
}
